import { Token } from './token.model';

/**
 * Usuario logueado y tókenes
 */
export class User {
  private _username: string;
  private _date: number;
  private _token: Token;

  constructor(username: string, accessToken: string, refreshToken?: string, date?: number) {
    this._username = username;
    this._token = new Token(accessToken, refreshToken);
    if (date === undefined || date == null) {
      this._date = new Date().getTime();
    }
  }

  public get username(): string {
    return this._username;
  }

  public get date(): number {
    return this._date;
  }

  public set username(value: string) {
    this._username = value;
  }

  public set date(value: number) {
    this._date = value;
  }

  public get token(): Token {
    return this._token;
  }

  public set token(value: Token) {
    this._token = value;
  }

  public getAccessToken() {
    return this._token.accessToken;
  }

  public getRefreshToken() {
    return this._token.refreshToken;
  }

}
